/* eslint-disable */

const initNaverAnalytics = () => {
  try {
    window.wcs_add = window.wcs_add || {};
    window.wcs_add['wa'] = 's_4f42d3095f05';
    window._nasa = window._nasa || {};

    // wcs 객체가 로드될 때까지 대기하는 함수
    const waitForWCS = () => {
      if (typeof wcs !== 'undefined') {
        wcs.inflow();
        wcs_do(_nasa);
      } else {
        console.error('Failed to load WCS after multiple retries');
      }
    };

    // wcs 초기화 시작
    waitForWCS();
  } catch (e) {
    console.error('Naver Analytics Error:', e);
  }
};

const initAppsFlyerAnalytics = (isNativeAppBoth = false) => {
  try {
    var WCKAppsFlyer = new WCKAppsFlyer();
    !(function (t, e, n, s, a, c, i, o, p) {
      (t.AppsFlyerSdkObject = a),
        (t.AF =
          t.AF ||
          function () {
            (t.AF.q = t.AF.q || []).push(
              [Date.now()].concat(Array.prototype.slice.call(arguments))
            );
          }),
        (t.AF.id = t.AF.id || i),
        (t.AF.plugins = {}),
        (o = e.createElement(n)),
        (p = e.getElementsByTagName(n)[0]),
        (o.async = 1),
        (o.src =
          'https://websdk.appsflyer.com?' +
          (c.length > 0 ? 'st=' + c.split(',').sort().join(',') + '&' : '') +
          (i.length > 0 ? 'af_id=' + i : '')),
        p.parentNode.insertBefore(o, p);
    })(window, document, 'script', 0, 'AF', 'banners', {
      pba: { webAppId: process.env.NEXT_PUBLIC_APPS_FLYER_PBA_KEY },
      banners: { key: process.env.NEXT_PUBLIC_APPS_FLYER_BANNER_KEY },
    });
    isNativeAppBoth && AF('banners', 'showBanner');
  } catch (e) {
    console.error(e);
  }
};

export { initNaverAnalytics, initAppsFlyerAnalytics };
